import { css, keyframes } from 'styled-components';
import { theme } from '~ui-kit/theme';

const placeholderPulseKeyframes = keyframes`
  0% { opacity: 1; }
  50% { opacity: 0.6; }
  100% { opacity: 1; }
`;

export const placeholderBaseStyle = css`
  background-color: ${theme.colors.placeholder};
  animation: ${placeholderPulseKeyframes} 1.5s infinite ease-in-out;
`;
